function getMetadata(missionId) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
  };

  // nginx proxies /metadata/* to mission-metadata.js-identity.svc.cluster.local:8443
  return fetch(`/metadata/${missionId}`, requestOptions);
}

export const metadataService = {
  getMetadata,
};
